module.exports = __webpack_public_path__ + "img/iconfinder_trello_2317760.2996cf54.svg";